export default __webpack_public_path__ + "static/media/logga.6d91888e.png";